import { createApp } from "vue"
import { createHead } from "@unhead/vue"
import { createGtm } from "@gtm-support/vue-gtm"
import { registerScrollSpy } from "vue3-scroll-spy"
import App from "@/App.vue"
import VueCookieAcceptDecline from "vue-cookie-accept-decline"
import "vue-cookie-accept-decline/dist/vue-cookie-accept-decline.css"
import FlagIcon from "vue-flag-icon"
import VueSafeHTML, { allowedTags } from "vue-safe-html"

import Notifications from "notiwind"
import VueGoogleMaps from "vue-google-maps-community-fork"
import VuePlyr from "@skjnldsv/vue-plyr"
import InstantSearch from "vue-instantsearch/vue3/es"
import "@skjnldsv/vue-plyr/dist/vue-plyr.css"
import axios from "axios"
import { fr } from "yup-locales"
import { setLocale } from "yup"
import i18n from "./i18n"
import router from "@/router"
import store from "@/store"
import { QuillEditor } from "@vueup/vue-quill"
import "@vueup/vue-quill/dist/vue-quill.snow.css"
import AOS from "aos"
import VueExpandableImage from "@common/utils/expandable-image"
import "aos/dist/aos.css"
import "@projetsolaire/ui/style.css"
import "@assets/css/style.css"

window.axios = axios

axios.defaults.baseURL = import.meta.env.VITE_ROOT_API
setLocale(fr)

const auth =
  localStorage.getItem("auth") && JSON.parse(localStorage.getItem("auth"))

if (auth && auth.token && auth.expiresAt > Date.now()) {
  window.axios.defaults.headers.common["Authorization"] = `Bearer ${auth.token}`
  store.commit("auth/login", auth)
} else if (auth) {
  localStorage.removeItem("auth")
}

const app = createApp(App)

//Disable Vue DevTools in prod
if (import.meta.env.MODE === "production") {
  if (window.__VUE_DEVTOOLS_GLOBAL_HOOK__) {
    window.__VUE_DEVTOOLS_GLOBAL_HOOK__.off()
  }
}

const head = createHead()
const gdpr = localStorage.getItem("vue-cookie-accept-decline-gdpr")
app.use(
  createGtm({
    id: import.meta.env.VITE_GTM_ID, // Your GTM single container ID, array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy'] or array of objects [{id: 'GTM-xxxxxx', queryParams: { gtm_auth: 'abc123', gtm_preview: 'env-4', gtm_cookies_win: 'x'}}, {id: 'GTM-yyyyyy', queryParams: {gtm_auth: 'abc234', gtm_preview: 'env-5', gtm_cookies_win: 'x'}}], // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy']
    defer: false, // Script can be set to `defer` to speed up page load at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible). Defaults to false, so the script is loaded `async` by default
    enabled: gdpr == "accept", // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
    debug: import.meta.env.MODE == "development", // Whether or not display console logs debugs (optional)
    loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
    vueRouter: router, // Pass the router instance to automatically sync with router (optional)
    trackOnNextTick: false, // Whether or not call trackView in Vue.nextTick
  }),
)
registerScrollSpy(app)
app.component("QuillEditor", QuillEditor)
app.component("VueCookieAcceptDecline", VueCookieAcceptDecline)
app.use(head)
app.use(i18n)
app.use(router)
app.use(store)
app.use(InstantSearch)
app.use(Notifications)
app.use(VueSafeHTML, {
  allowedTags: [
    ...allowedTags,
    "span",
    "blockquote",
    "div",
    "p",
    "ul",
    "li",
    "a",
  ],
  allowedAttributes: ["title", "class", "href", "style"],
})
app.use(VueGoogleMaps, {
  load: {
    key: import.meta.env.VITE_GMAPS_KEY,
    libraries: "places",
  },
})
app.use(VuePlyr)
app.use(FlagIcon)
app.use(
  AOS.init({
    once: true,
    disable: "phone",
    duration: 700,
    easing: "ease-out-cubic",
  }),
)
app.use(VueExpandableImage)
app.mount("#app")
